// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadersHeroContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.spacingBox {
  /* margin-right: 0.73vw; */
}
/* Active Styling */
.loadersHeroActive {
  width: 6.22vw;
  height: 6.22vw;
  transform: rotate(-135deg);

  background: #fefefe;
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08) !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loadersHeroActive img {
  width: 1.53vw;
  margin-bottom: 0.65vw;
}
.loadersHeroActive p {
  width: 6vw;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.73vw;
  /* or 10.29vw */
  line-height: 1.3;

  text-align: center;

  color: #383838;
}

.buttonActive {
  border: 0;
  box-sizing: border-box;

  border-radius: 50%;

  position: relative;
  vertical-align: middle;

  &::before,
  &::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.spinActive {
  transform: rotate(135deg);
  width: 7.32vw;
  height: 7.32vw;

  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.73vw;

  &:hover {
    color: #548dff;
  }

  &::before,
  &::after {
    top: 0;
    left: 0;
  }

  &::before {
    border: 0.17vw solid transparent;
  }

  &::before {
    border-bottom-color: #548dff;

    transition: border-top-color 0.15s linear,
      border-right-color 0.15s linear 0.1s,
      border-bottom-color 0.15s linear 0.45s;
  }

  &::after {
    border: 0 solid transparent;
  }

  &::after {
    border-top: 0.17vw solid #548dff;
    border-left-width: 0.17vw;
    border-right-width: 0.17vw;
    transform: rotate(270deg);
    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
  }
}

.circleActive {
  border-radius: 100%;
  box-shadow: none;

  &::before,
  &::after {
    border-radius: 100%;
  }
}
/* Blue 2 styling */
.loadersHero6 {
  width: 6.22vw;
  height: 6.22vw;
  transform: rotate(-135deg);

  background: #fefefe;
  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loadersHero6 img {
  width: 1.53vw;
  margin-bottom: 0.65vw;
}
.loadersHero6 p {
  width: 7vw;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.73vw;
  /* or 10.29vw */
  line-height: 1.3;

  text-align: center;

  color: #383838;
}

.button6 {
  border: 0;
  box-sizing: border-box;
  width: 8.78vw;
  height: 8.78vw;
  border-radius: 50%;
  /* padding: 1em 2em; */
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

  position: relative;
  vertical-align: middle;

  &::before,
  &::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.spin6 {
  transform: rotate(135deg);
  width: 7.32vw;
  height: 7.32vw;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #548dff;
  }

  &::before,
  &::after {
    top: 0;
    left: 0;
  }

  &::before {
    border: 0.17vw solid transparent;
  }

  &:hover::before {
    border-bottom-color: #548dff;

    transition: border-top-color 0.15s linear,
      border-right-color 0.15s linear 0.1s,
      border-bottom-color 0.15s linear 0.45s;
  }

  &::after {
    border: 0 solid transparent;
  }

  &:hover::after {
    border-top: 0.17vw solid #548dff;
    border-left-width: 0.17vw;
    border-right-width: 0.17vw;
    transform: rotate(270deg);
    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
  }
}

.circle6 {
  border-radius: 100%;
  box-shadow: none;

  &::before,
  &::after {
    border-radius: 100%;
  }
}
.button6:hover {
  transform: scale(1.1) rotate(135deg);
  /* transform: rotate(45deg); */
}

/* Blue top animation */
.loadersHero {
  width: 6.22vw;
  height: 6.22vw;
  transform: rotate(-135deg);

  background: #fefefe;
  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-top: 0.36vw solid #333;
  border-bottom: none;
  border-left: 0.36vw solid #333; */
  /* border: 0.36vw 0.36vw 0 0 solid red; */
  /* border-right: none; */
}
.loadersHero img {
  width: 1.53vw;
  margin-bottom: 0.65vw;
}
.loadersHero p {
  width: 6vw;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.73vw;
  /* or 10.29vw */
  line-height: 1.3;

  text-align: center;

  color: #383838;
}

.button {
  /* border: 0; */
  box-sizing: border-box;
  width: 8.78vw;
  height: 8.78vw;
  border-radius: 50%;
  /* padding: 1em 2em; */
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

  position: relative;
  vertical-align: middle;

  &::before,
  &::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.spin {
  transform: rotate(135deg);
  width: 7.32vw;
  height: 7.32vw;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #548dff;
  }

  &::before,
  &::after {
    top: 0;
    left: 0;
  }

  &::before {
    border: 0.17vw solid transparent;
  }

  &:hover::before {
    /* border-top-color: #548DFF; */
    /* border-right-color: #548dff; */
    border-bottom-color: #548dff;

    transition: border-top-color 0.15s linear,
      border-right-color 0.15s linear 0.1s,
      border-bottom-color 0.15s linear 0.45s;
  }

  &::after {
    border: 0 solid transparent;
  }

  &:hover::after {
    border-top: 0.17vw solid #548dff;
    border-left-width: 0.17vw;
    border-right-width: 0.17vw;
    transform: rotate(270deg);
    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
  }
}

.circle {
  border-radius: 100%;
  box-shadow: none;

  &::before,
  &::after {
    border-radius: 100%;
  }
}
.button:hover {
  transform: scale(1.1) rotate(135deg);
  /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */
  /* transform: rotate(45deg); */
}

/* Red bottom animations */
.loadersHero2 {
  width: 6.22vw;
  height: 6.22vw;
  transform: rotate(-45deg);

  background: #fefefe;
  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loadersHero2 img {
  width: 1.53vw;
  margin-bottom: 0.65vw;
}
.loadersHero2 p {
  width: 6vw;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.73vw;
  /* or 10.29vw */
  line-height: 1.3;

  text-align: center;

  color: #383838;
}

.button2 {
  border: 0;
  box-sizing: border-box;
  width: 8.78vw;
  height: 8.78vw;
  border-radius: 50%;
  /* padding: 1em 2em; */
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

  position: relative;
  vertical-align: middle;

  &::before,
  &::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.spin2 {
  transform: rotate(45deg);
  width: 7.32vw;
  height: 7.32vw;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #ff0202;
  }

  &::before,
  &::after {
    top: 0;
    left: 0;
  }

  &::before {
    border: 0.17vw solid transparent;
  }

  &:hover::before {
    border-bottom-color: #ff0202;

    transition: border-top-color 0.15s linear,
      border-right-color 0.15s linear 0.1s,
      border-bottom-color 0.15s linear 0.45s;
  }

  &::after {
    border: 0 solid transparent;
  }

  &:hover::after {
    border-top: 0.17vw solid #ff0202;
    border-left-width: 0.17vw;
    border-right-width: 0.17vw;

    transform: rotate(-270deg);
    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
  }
}
.button2:hover {
  transform: scale(1.1) rotate(45deg);
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);
  /* transform: rotate(45deg); */
}
.circle2 {
  border-radius: 100%;
  box-shadow: none;

  &::before,
  &::after {
    border-radius: 100%;
  }
}

/* Green top animation */
.loadersHero3 {
  width: 6.22vw;
  height: 6.22vw;
  transform: rotate(-135deg);

  background: #fefefe;
  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-top: 0.36vw solid #333;
  border-bottom: none;
  border-left: 0.36vw solid #333; */
  /* border: 0.36vw 0.36vw 0 0 solid red; */
  /* border-right: none; */
}
.loadersHero3 img {
  width: 1.53vw;
  margin-bottom: 0.65vw;
}
.loadersHero3 p {
  width: 5vw;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.73vw;
  /* or 10.29vw */
  line-height: 1.3;

  text-align: center;

  color: #383838;
}

.button3 {
  border: 0;
  box-sizing: border-box;
  width: 8.78vw;
  height: 8.78vw;
  border-radius: 50%;
  /* padding: 1em 2em; */
  /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */

  position: relative;
  vertical-align: middle;

  &::before,
  &::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.spin3 {
  transform: rotate(135deg);
  width: 7.32vw;
  height: 7.32vw;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #20cc31;
  }

  &::before,
  &::after {
    top: 0;
    left: 0;
  }

  &::before {
    border: 0.17vw solid transparent;
  }

  &:hover::before {
    /* border-top-color: #548DFF; */
    /* border-right-color: #548dff; */
    border-bottom-color: #20cc31;

    transition: border-top-color 0.15s linear,
      border-right-color 0.15s linear 0.1s,
      border-bottom-color 0.15s linear 0.45s;
  }

  &::after {
    border: 0 solid transparent;
  }

  &:hover::after {
    border-top: 0.17vw solid #20cc31;
    border-left-width: 0.17vw;
    border-right-width: 0.17vw;
    transform: rotate(270deg);
    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
  }
}

.circle3 {
  border-radius: 100%;
  box-shadow: none;

  &::before,
  &::after {
    border-radius: 100%;
  }
}
.button3:hover {
  transform: scale(1.1) rotate(135deg);
  /* transform: scale(1.1); */
  /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */

  /* transform: rotate(45deg); */
}

/* Yellow Bottom Animation  */

.loadersHero4 {
  width: 6.22vw;
  height: 6.22vw;
  transform: rotate(-45deg);

  background: #fefefe;
  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loadersHero4 img {
  width: 1.53vw;
  margin-bottom: 0.65vw;
}
.loadersHero4 p {
  width: 7vw;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.73vw;
  /* or 10.29vw */
  line-height: 1.3;

  text-align: center;

  color: #383838;
}

.button4 {
  border: 0;
  box-sizing: border-box;
  width: 8.78vw;
  height: 8.78vw;
  border-radius: 50%;
  /* padding: 1em 2em; */
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

  position: relative;
  vertical-align: middle;

  &::before,
  &::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.spin4 {
  transform: rotate(45deg);
  width: 7.32vw;
  height: 7.32vw;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #ffcb14;
  }

  &::before,
  &::after {
    top: 0;
    left: 0;
  }

  &::before {
    border: 0.17vw solid transparent;
  }

  &:hover::before {
    /* border-top-color: #548DFF; */
    /* border-right-color: #548dff; */
    border-bottom-color: #ffcb14;

    transition: border-top-color 0.15s linear,
      border-right-color 0.15s linear 0.1s,
      border-bottom-color 0.15s linear 0.45s;
  }

  &::after {
    border: 0 solid transparent;
  }

  &:hover::after {
    border-top: 0.17vw solid #ffcb14;
    border-left-width: 0.17vw;
    border-right-width: 0.17vw;
    transform: rotate(-270deg);
    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
  }
}
.button4:hover {
  transform: scale(1.1) rotate(45deg);
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);
  /* transform: rotate(45deg); */
}
.circle4 {
  border-radius: 100%;
  box-shadow: none;

  &::before,
  &::after {
    border-radius: 100%;
  }
}

/* Pink Bottom Animation */
.loadersHero5 {
  width: 6.22vw;
  height: 6.22vw;
  transform: rotate(-45deg);

  background: #fefefe;
  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loadersHero5 img {
  width: 1.53vw;
  margin-bottom: 0.65vw;
}
.loadersHero5 p {
  width: 7vw;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 0.73vw;
  /* or 10.29vw */
  line-height: 1.3;

  text-align: center;

  color: #383838;
}

.button5 {
  border: 0;
  box-sizing: border-box;
  width: 8.78vw;
  height: 8.78vw;
  border-radius: 50%;
  /* padding: 1em 2em; */
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

  position: relative;
  vertical-align: middle;

  &::before,
  &::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.spin5 {
  transform: rotate(45deg);
  width: 7.32vw;
  height: 7.32vw;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #ff547d;
  }

  &::before,
  &::after {
    top: 0;
    left: 0;
  }

  &::before {
    border: 0.17vw solid transparent;
  }

  &:hover::before {
    /* border-top-color: #548DFF; */
    /* border-right-color: #548dff; */
    border-bottom-color: #ff547d;

    transition: border-top-color 0.15s linear,
      border-right-color 0.15s linear 0.1s,
      border-bottom-color 0.15s linear 0.45s;
  }

  &::after {
    border: 0 solid transparent;
  }

  &:hover::after {
    border-top: 0.17vw solid #ff547d;
    border-left-width: 0.17vw;
    border-right-width: 0.17vw;
    transform: rotate(-270deg);
    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
  }
}
.button5:hover {
  transform: scale(1.1) rotate(45deg);
  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);
  /* transform: rotate(45deg); */
}
.circle5 {
  border-radius: 100%;
  box-shadow: none;

  &::before,
  &::after {
    border-radius: 100%;
  }
}

@media only screen and (max-width: 767px) {
  .loadersHeroContainer {
    padding: 0 0rem;
    width: 100%;
    display: flex;
    /* flex-direction: column; */
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .spacingBox {
    /* margin-right: 0.73vw; */
  }
  /* Active Styling */
  .loadersHeroActive {
    width: 100px;
    height: 100px;
    transform: rotate(-135deg);

    background: #fefefe;
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08) !important;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .loadersHeroActive img {
    width: 30px;
    margin-bottom: 0.65vw;
  }
  .loadersHeroActive p {
    width: 70px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    text-align: center;
    color: #383838;
    margin-top: 5px;
  }

  .buttonActive {
    border: 0;
    box-sizing: border-box;

    border-radius: 50%;

    position: relative;
    vertical-align: middle;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .spinActive {
    transform: rotate(135deg);
    width: 120px;
    height: 120px;

    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.73vw;

    &:hover {
      color: #548dff;
    }

    &::before,
    &::after {
      top: 0;
      left: 0;
    }

    &::before {
      border: 2.4px solid transparent;
    }

    &::before {
      border-bottom-color: #548dff;

      transition: border-top-color 0.15s linear,
        border-right-color 0.15s linear 0.1s,
        border-bottom-color 0.15s linear 0.45s;
    }

    &::after {
      border: 0 solid transparent;
    }

    &::after {
      border-top: 2.4px solid #548dff;
      border-left-width: 2.4px;
      border-right-width: 2.4px;
      transform: rotate(270deg);
      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
    }
  }

  .circleActive {
    border-radius: 100%;
    box-shadow: none;

    &::before,
    &::after {
      border-radius: 100%;
    }
  }

  /* Blue 2 styling */
  .loadersHero6 {
    width: 100px;
    height: 100px;
    transform: rotate(-135deg);

    background: #fefefe;
    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .loadersHero6 img {
    width: 25px;
    margin-bottom: 0.65vw;
  }
  .loadersHero6 p {
    width: 80px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    text-align: center;
    color: #383838;
    margin-top: 3px;
  }

  .button6 {
    border: 0;
    box-sizing: border-box;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    /* padding: 1em 2em; */
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

    position: relative;
    vertical-align: middle;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .spin6 {
    transform: rotate(135deg);
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: #548dff;
    }

    &::before,
    &::after {
      top: 0;
      left: 0;
    }

    &::before {
      border: 2.4px solid transparent;
    }

    &:hover::before {
      border-bottom-color: #548dff;

      transition: border-top-color 0.15s linear,
        border-right-color 0.15s linear 0.1s,
        border-bottom-color 0.15s linear 0.45s;
    }

    &::after {
      border: 0 solid transparent;
    }

    &:hover::after {
      border-top: 2.4px solid #548dff;
      border-left-width: 2.4px;
      border-right-width: 2.4px;
      transform: rotate(270deg);
      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
    }
  }

  .circle6 {
    border-radius: 100%;
    box-shadow: none;

    &::before,
    &::after {
      border-radius: 100%;
    }
  }
  .button6:hover {
    transform: scale(1.1) rotate(135deg);
    /* transform: rotate(45deg); */
  }

  /* Blue top animation */
  .loadersHero {
    width: 100px;
    height: 100px;
    transform: rotate(-135deg);

    background: #fefefe;
    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-top: 0.36vw solid #333;
  border-bottom: none;
  border-left: 0.36vw solid #333; */
    /* border: 0.36vw 0.36vw 0 0 solid red; */
    /* border-right: none; */
  }
  .loadersHero img {
    width: 25px;
    margin-bottom: 0.65vw;
  }
  .loadersHero p {
    width: 30px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    margin-top: 3px;
    text-align: center;
    color: #383838;
  }

  .button {
    /* border: 0; */
    box-sizing: border-box;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    /* padding: 1em 2em; */
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

    position: relative;
    vertical-align: middle;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .spin {
    transform: rotate(135deg);
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: #548dff;
    }

    &::before,
    &::after {
      top: 0;
      left: 0;
    }

    &::before {
      border: 2.4px solid transparent;
    }

    &:hover::before {
      /* border-top-color: #548DFF; */
      /* border-right-color: #548dff; */
      border-bottom-color: #548dff;

      transition: border-top-color 0.15s linear,
        border-right-color 0.15s linear 0.1s,
        border-bottom-color 0.15s linear 0.45s;
    }

    &::after {
      border: 0 solid transparent;
    }

    &:hover::after {
      border-top: 2.4px solid #548dff;
      border-left-width: 2.4px;
      border-right-width: 2.4px;
      transform: rotate(270deg);
      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
    }
  }

  .circle {
    border-radius: 100%;
    box-shadow: none;

    &::before,
    &::after {
      border-radius: 100%;
    }
  }
  .button:hover {
    transform: scale(1.1) rotate(135deg);
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);
    /* transform: rotate(45deg); */
  }

  /* Red bottom animations */
  .loadersHero2 {
    width: 100px;
    height: 100px;
    transform: rotate(-45deg);

    background: #fefefe;
    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .loadersHero2 img {
    width: 25px;
    margin-bottom: 0.65vw;
  }
  .loadersHero2 p {
    width: 80px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    margin-top: 5px;
    text-align: center;
    color: #383838;
  }

  .button2 {
    border: 0;
    box-sizing: border-box;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    /* padding: 1em 2em; */
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

    position: relative;
    vertical-align: middle;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .spin2 {
    transform: rotate(45deg);
    width: 110px;
    height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: #ff0202;
    }

    &::before,
    &::after {
      top: 0;
      left: 0;
    }

    &::before {
      border: 2.4px solid transparent;
    }

    &:hover::before {
      border-bottom-color: #ff0202;

      transition: border-top-color 0.15s linear,
        border-right-color 0.15s linear 0.1s,
        border-bottom-color 0.15s linear 0.45s;
    }

    &::after {
      border: 0 solid transparent;
    }

    &:hover::after {
      border-top: 2.4px solid #ff0202;
      border-left-width: 2.4px;
      border-right-width: 2.4px;

      transform: rotate(-270deg);
      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
    }
  }
  .button2:hover {
    transform: scale(1.1) rotate(45deg);
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);
    /* transform: rotate(45deg); */
  }
  .circle2 {
    border-radius: 100%;
    box-shadow: none;

    &::before,
    &::after {
      border-radius: 100%;
    }
  }

  /* Green top animation */
  .loadersHero3 {
    width: 100px;
    height: 100px;
    transform: rotate(-135deg);

    background: #fefefe;
    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border-top: 0.36vw solid #333;
  border-bottom: none;
  border-left: 0.36vw solid #333; */
    /* border: 0.36vw 0.36vw 0 0 solid red; */
    /* border-right: none; */
  }
  .loadersHero3 img {
    width: 20px;
    margin-bottom: 0.65vw;
  }
  .loadersHero3 p {
    width: 70px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    margin-top: 5px;
    text-align: center;
    color: #383838;
  }

  .button3 {
    border: 0;
    box-sizing: border-box;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    /* padding: 1em 2em; */
    /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */

    position: relative;
    vertical-align: middle;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .spin3 {
    transform: rotate(135deg);
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: #20cc31;
    }

    &::before,
    &::after {
      top: 0;
      left: 0;
    }

    &::before {
      border: 2.4px solid transparent;
    }

    &:hover::before {
      /* border-top-color: #548DFF; */
      /* border-right-color: #548dff; */
      border-bottom-color: #20cc31;

      transition: border-top-color 0.15s linear,
        border-right-color 0.15s linear 0.1s,
        border-bottom-color 0.15s linear 0.45s;
    }

    &::after {
      border: 0 solid transparent;
    }

    &:hover::after {
      border-top: 2.4px solid #20cc31;
      border-left-width: 2.4px;
      border-right-width: 2.4px;
      transform: rotate(270deg);
      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
    }
  }

  .circle3 {
    border-radius: 100%;
    box-shadow: none;

    &::before,
    &::after {
      border-radius: 100%;
    }
  }
  .button3:hover {
    transform: scale(1.1) rotate(135deg);
    /* transform: scale(1.1); */
    /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */

    /* transform: rotate(45deg); */
  }

  /* Yellow Bottom Animation  */

  .loadersHero4 {
    width: 100px;
    height: 100px;
    transform: rotate(-45deg);

    background: #fefefe;
    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .loadersHero4 img {
    width: 20px;
    margin-bottom: 0.65vw;
  }
  .loadersHero4 p {
    width: 50px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    margin-top: 4px;
    text-align: center;
    color: #383838;
  }

  .button4 {
    border: 0;
    box-sizing: border-box;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    /* padding: 1em 2em; */
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

    position: relative;
    vertical-align: middle;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .spin4 {
    transform: rotate(45deg);
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: #ffcb14;
    }

    &::before,
    &::after {
      top: 0;
      left: 0;
    }

    &::before {
      border: 2.4px solid transparent;
    }

    &:hover::before {
      /* border-top-color: #548DFF; */
      /* border-right-color: #548dff; */
      border-bottom-color: #ffcb14;

      transition: border-top-color 0.15s linear,
        border-right-color 0.15s linear 0.1s,
        border-bottom-color 0.15s linear 0.45s;
    }

    &::after {
      border: 0 solid transparent;
    }

    &:hover::after {
      border-top: 2.4px solid #ffcb14;
      border-left-width: 2.4px;
      border-right-width: 2.4px;
      transform: rotate(-270deg);
      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
    }
  }
  .button4:hover {
    transform: scale(1.1) rotate(45deg);
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);
    /* transform: rotate(45deg); */
  }
  .circle4 {
    border-radius: 100%;
    box-shadow: none;

    &::before,
    &::after {
      border-radius: 100%;
    }
  }

  /* Pink Bottom Animation */
  .loadersHero5 {
    width: 100px;
    height: 100px;
    transform: rotate(-45deg);

    background: #fefefe;
    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .loadersHero5 img {
    width: 25px;
    margin-bottom: 0.65vw;
  }
  .loadersHero5 p {
    width: 80px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    margin-top: 4px;
    text-align: center;
    color: #383838;
  }

  .button5 {
    border: 0;
    box-sizing: border-box;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    /* padding: 1em 2em; */
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);

    position: relative;
    vertical-align: middle;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .spin5 {
    transform: rotate(45deg);
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: #ff547d;
    }

    &::before,
    &::after {
      top: 0;
      left: 0;
    }

    &::before {
      border: 2.4px solid transparent;
    }

    &:hover::before {
      /* border-top-color: #548DFF; */
      /* border-right-color: #548dff; */
      border-bottom-color: #ff547d;

      transition: border-top-color 0.15s linear,
        border-right-color 0.15s linear 0.1s,
        border-bottom-color 0.15s linear 0.45s;
    }

    &::after {
      border: 0 solid transparent;
    }

    &:hover::after {
      border-top: 2.4px solid #ff547d;
      border-left-width: 2.4px;
      border-right-width: 2.4px;
      transform: rotate(-270deg);
      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;
    }
  }
  .button5:hover {
    transform: scale(1.1) rotate(45deg);
    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);
    /* transform: rotate(45deg); */
  }
  .circle5 {
    border-radius: 100%;
    box-shadow: none;

    &::before,
    &::after {
      border-radius: 100%;
    }
  }

  .marginLoader {
    /* margin: 0 5px; */
    margin-bottom: 5px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/WebHomePage/Reusable/RoundLoader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;;EAE1B,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;;EAEV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;;EAEtB,kBAAkB;;EAElB,kBAAkB;EAClB,sBAAsB;;EAEtB;;IAEE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;;EAEd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;;EAEpB;IACE,cAAc;EAChB;;EAEA;;IAEE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;;IAE5B;;4CAEwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;IACzB,wEAAwE;EAC1E;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;;EAEhB;;IAEE,mBAAmB;EACrB;AACF;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;;EAE1B,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;;EAEV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;;EAE/C,kBAAkB;EAClB,sBAAsB;;EAEtB;;IAEE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;;EAEA;;IAEE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;;IAE5B;;4CAEwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;IACzB,wEAAwE;EAC1E;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;;EAEhB;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;;EAE1B,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB;;mCAEiC;EACjC,yCAAyC;EACzC,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;;EAEV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;;EAE/C,kBAAkB;EAClB,sBAAsB;;EAEtB;;IAEE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;;EAEA;;IAEE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;IAC/B,iCAAiC;IACjC,4BAA4B;;IAE5B;;4CAEwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;IACzB,wEAAwE;EAC1E;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;;EAEhB;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;;EAEzB,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;;EAEV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;;EAE/C,kBAAkB;EAClB,sBAAsB;;EAEtB;;IAEE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;;EAEA;;IAEE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,4BAA4B;;IAE5B;;4CAEwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;;IAE1B,0BAA0B;IAC1B,wEAAwE;EAC1E;AACF;AACA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;;EAEhB;;IAEE,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;;EAE1B,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB;;mCAEiC;EACjC,yCAAyC;EACzC,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,qDAAqD;;EAErD,kBAAkB;EAClB,sBAAsB;;EAEtB;;IAEE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;;EAEA;;IAEE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;IAC/B,iCAAiC;IACjC,4BAA4B;;IAE5B;;4CAEwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;IACzB,wEAAwE;EAC1E;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;;EAEhB;;IAEE,mBAAmB;EACrB;AACF;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qDAAqD;;EAErD,8BAA8B;AAChC;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;;EAEzB,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;;EAEV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;;EAE/C,kBAAkB;EAClB,sBAAsB;;EAEtB;;IAEE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;;EAEA;;IAEE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;IAC/B,iCAAiC;IACjC,4BAA4B;;IAE5B;;4CAEwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,wEAAwE;EAC1E;AACF;AACA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;;EAEhB;;IAEE,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;;EAEzB,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,+CAA+C;;EAE/C,kBAAkB;EAClB,sBAAsB;;EAEtB;;IAEE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;;EAEA;;IAEE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;IAC/B,iCAAiC;IACjC,4BAA4B;;IAE5B;;4CAEwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,wEAAwE;EAC1E;AACF;AACA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;;EAEhB;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA,mBAAmB;EACnB;IACE,YAAY;IACZ,aAAa;IACb,0BAA0B;;IAE1B,mBAAmB;IACnB,0DAA0D;IAC1D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;;IAEX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,sBAAsB;;IAEtB,kBAAkB;;IAElB,kBAAkB;IAClB,sBAAsB;;IAEtB;;MAEE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;;IAEb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;;IAEpB;MACE,cAAc;IAChB;;IAEA;;MAEE,MAAM;MACN,OAAO;IACT;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,4BAA4B;;MAE5B;;8CAEwC;IAC1C;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,wBAAwB;MACxB,yBAAyB;MACzB,yBAAyB;MACzB,wEAAwE;IAC1E;EACF;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;;IAEhB;;MAEE,mBAAmB;IACrB;EACF;;EAEA,mBAAmB;EACnB;IACE,YAAY;IACZ,aAAa;IACb,0BAA0B;;IAE1B,mBAAmB;IACnB,0DAA0D;IAC1D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,+CAA+C;;IAE/C,kBAAkB;IAClB,sBAAsB;;IAEtB;;MAEE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,cAAc;IAChB;;IAEA;;MAEE,MAAM;MACN,OAAO;IACT;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,4BAA4B;;MAE5B;;8CAEwC;IAC1C;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,wBAAwB;MACxB,yBAAyB;MACzB,yBAAyB;MACzB,wEAAwE;IAC1E;EACF;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;;IAEhB;;MAEE,mBAAmB;IACrB;EACF;EACA;IACE,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA,uBAAuB;EACvB;IACE,YAAY;IACZ,aAAa;IACb,0BAA0B;;IAE1B,mBAAmB;IACnB,0DAA0D;IAC1D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;;mCAE+B;IAC/B,yCAAyC;IACzC,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;;IAEX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,+CAA+C;;IAE/C,kBAAkB;IAClB,sBAAsB;;IAEtB;;MAEE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,cAAc;IAChB;;IAEA;;MAEE,MAAM;MACN,OAAO;IACT;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,+BAA+B;MAC/B,iCAAiC;MACjC,4BAA4B;;MAE5B;;8CAEwC;IAC1C;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,wBAAwB;MACxB,yBAAyB;MACzB,yBAAyB;MACzB,wEAAwE;IAC1E;EACF;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;;IAEhB;;MAEE,mBAAmB;IACrB;EACF;EACA;IACE,oCAAoC;IACpC,+CAA+C;IAC/C,8BAA8B;EAChC;;EAEA,0BAA0B;EAC1B;IACE,YAAY;IACZ,aAAa;IACb,yBAAyB;;IAEzB,mBAAmB;IACnB,0DAA0D;IAC1D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;;IAEX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,+CAA+C;;IAE/C,kBAAkB;IAClB,sBAAsB;;IAEtB;;MAEE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,cAAc;IAChB;;IAEA;;MAEE,MAAM;MACN,OAAO;IACT;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,4BAA4B;;MAE5B;;8CAEwC;IAC1C;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,wBAAwB;MACxB,yBAAyB;;MAEzB,0BAA0B;MAC1B,wEAAwE;IAC1E;EACF;EACA;IACE,mCAAmC;IACnC,+CAA+C;IAC/C,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,gBAAgB;;IAEhB;;MAEE,mBAAmB;IACrB;EACF;;EAEA,wBAAwB;EACxB;IACE,YAAY;IACZ,aAAa;IACb,0BAA0B;;IAE1B,mBAAmB;IACnB,0DAA0D;IAC1D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;;mCAE+B;IAC/B,yCAAyC;IACzC,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,qDAAqD;;IAErD,kBAAkB;IAClB,sBAAsB;;IAEtB;;MAEE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,cAAc;IAChB;;IAEA;;MAEE,MAAM;MACN,OAAO;IACT;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,+BAA+B;MAC/B,iCAAiC;MACjC,4BAA4B;;MAE5B;;8CAEwC;IAC1C;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,wBAAwB;MACxB,yBAAyB;MACzB,yBAAyB;MACzB,wEAAwE;IAC1E;EACF;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;;IAEhB;;MAEE,mBAAmB;IACrB;EACF;EACA;IACE,oCAAoC;IACpC,2BAA2B;IAC3B,qDAAqD;;IAErD,8BAA8B;EAChC;;EAEA,6BAA6B;;EAE7B;IACE,YAAY;IACZ,aAAa;IACb,yBAAyB;;IAEzB,mBAAmB;IACnB,0DAA0D;IAC1D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,+CAA+C;;IAE/C,kBAAkB;IAClB,sBAAsB;;IAEtB;;MAEE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,cAAc;IAChB;;IAEA;;MAEE,MAAM;MACN,OAAO;IACT;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,+BAA+B;MAC/B,iCAAiC;MACjC,4BAA4B;;MAE5B;;8CAEwC;IAC1C;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,wBAAwB;MACxB,yBAAyB;MACzB,0BAA0B;MAC1B,wEAAwE;IAC1E;EACF;EACA;IACE,mCAAmC;IACnC,+CAA+C;IAC/C,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,gBAAgB;;IAEhB;;MAEE,mBAAmB;IACrB;EACF;;EAEA,0BAA0B;EAC1B;IACE,YAAY;IACZ,aAAa;IACb,yBAAyB;;IAEzB,mBAAmB;IACnB,0DAA0D;IAC1D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,+CAA+C;;IAE/C,kBAAkB;IAClB,sBAAsB;;IAEtB;;MAEE,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB;MACE,cAAc;IAChB;;IAEA;;MAEE,MAAM;MACN,OAAO;IACT;;IAEA;MACE,+BAA+B;IACjC;;IAEA;MACE,+BAA+B;MAC/B,iCAAiC;MACjC,4BAA4B;;MAE5B;;8CAEwC;IAC1C;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,wBAAwB;MACxB,yBAAyB;MACzB,0BAA0B;MAC1B,wEAAwE;IAC1E;EACF;EACA;IACE,mCAAmC;IACnC,+CAA+C;IAC/C,8BAA8B;EAChC;EACA;IACE,mBAAmB;IACnB,gBAAgB;;IAEhB;;MAEE,mBAAmB;IACrB;EACF;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".loadersHeroContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.spacingBox {\n  /* margin-right: 0.73vw; */\n}\n/* Active Styling */\n.loadersHeroActive {\n  width: 6.22vw;\n  height: 6.22vw;\n  transform: rotate(-135deg);\n\n  background: #fefefe;\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08) !important;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.loadersHeroActive img {\n  width: 1.53vw;\n  margin-bottom: 0.65vw;\n}\n.loadersHeroActive p {\n  width: 6vw;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.73vw;\n  /* or 10.29vw */\n  line-height: 1.3;\n\n  text-align: center;\n\n  color: #383838;\n}\n\n.buttonActive {\n  border: 0;\n  box-sizing: border-box;\n\n  border-radius: 50%;\n\n  position: relative;\n  vertical-align: middle;\n\n  &::before,\n  &::after {\n    box-sizing: inherit;\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n}\n.spinActive {\n  transform: rotate(135deg);\n  width: 7.32vw;\n  height: 7.32vw;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 0.73vw;\n\n  &:hover {\n    color: #548dff;\n  }\n\n  &::before,\n  &::after {\n    top: 0;\n    left: 0;\n  }\n\n  &::before {\n    border: 0.17vw solid transparent;\n  }\n\n  &::before {\n    border-bottom-color: #548dff;\n\n    transition: border-top-color 0.15s linear,\n      border-right-color 0.15s linear 0.1s,\n      border-bottom-color 0.15s linear 0.45s;\n  }\n\n  &::after {\n    border: 0 solid transparent;\n  }\n\n  &::after {\n    border-top: 0.17vw solid #548dff;\n    border-left-width: 0.17vw;\n    border-right-width: 0.17vw;\n    transform: rotate(270deg);\n    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n  }\n}\n\n.circleActive {\n  border-radius: 100%;\n  box-shadow: none;\n\n  &::before,\n  &::after {\n    border-radius: 100%;\n  }\n}\n/* Blue 2 styling */\n.loadersHero6 {\n  width: 6.22vw;\n  height: 6.22vw;\n  transform: rotate(-135deg);\n\n  background: #fefefe;\n  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.loadersHero6 img {\n  width: 1.53vw;\n  margin-bottom: 0.65vw;\n}\n.loadersHero6 p {\n  width: 7vw;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.73vw;\n  /* or 10.29vw */\n  line-height: 1.3;\n\n  text-align: center;\n\n  color: #383838;\n}\n\n.button6 {\n  border: 0;\n  box-sizing: border-box;\n  width: 8.78vw;\n  height: 8.78vw;\n  border-radius: 50%;\n  /* padding: 1em 2em; */\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n  position: relative;\n  vertical-align: middle;\n\n  &::before,\n  &::after {\n    box-sizing: inherit;\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n}\n.spin6 {\n  transform: rotate(135deg);\n  width: 7.32vw;\n  height: 7.32vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    color: #548dff;\n  }\n\n  &::before,\n  &::after {\n    top: 0;\n    left: 0;\n  }\n\n  &::before {\n    border: 0.17vw solid transparent;\n  }\n\n  &:hover::before {\n    border-bottom-color: #548dff;\n\n    transition: border-top-color 0.15s linear,\n      border-right-color 0.15s linear 0.1s,\n      border-bottom-color 0.15s linear 0.45s;\n  }\n\n  &::after {\n    border: 0 solid transparent;\n  }\n\n  &:hover::after {\n    border-top: 0.17vw solid #548dff;\n    border-left-width: 0.17vw;\n    border-right-width: 0.17vw;\n    transform: rotate(270deg);\n    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n  }\n}\n\n.circle6 {\n  border-radius: 100%;\n  box-shadow: none;\n\n  &::before,\n  &::after {\n    border-radius: 100%;\n  }\n}\n.button6:hover {\n  transform: scale(1.1) rotate(135deg);\n  /* transform: rotate(45deg); */\n}\n\n/* Blue top animation */\n.loadersHero {\n  width: 6.22vw;\n  height: 6.22vw;\n  transform: rotate(-135deg);\n\n  background: #fefefe;\n  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /* border-top: 0.36vw solid #333;\n  border-bottom: none;\n  border-left: 0.36vw solid #333; */\n  /* border: 0.36vw 0.36vw 0 0 solid red; */\n  /* border-right: none; */\n}\n.loadersHero img {\n  width: 1.53vw;\n  margin-bottom: 0.65vw;\n}\n.loadersHero p {\n  width: 6vw;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.73vw;\n  /* or 10.29vw */\n  line-height: 1.3;\n\n  text-align: center;\n\n  color: #383838;\n}\n\n.button {\n  /* border: 0; */\n  box-sizing: border-box;\n  width: 8.78vw;\n  height: 8.78vw;\n  border-radius: 50%;\n  /* padding: 1em 2em; */\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n  position: relative;\n  vertical-align: middle;\n\n  &::before,\n  &::after {\n    box-sizing: inherit;\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n}\n.spin {\n  transform: rotate(135deg);\n  width: 7.32vw;\n  height: 7.32vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    color: #548dff;\n  }\n\n  &::before,\n  &::after {\n    top: 0;\n    left: 0;\n  }\n\n  &::before {\n    border: 0.17vw solid transparent;\n  }\n\n  &:hover::before {\n    /* border-top-color: #548DFF; */\n    /* border-right-color: #548dff; */\n    border-bottom-color: #548dff;\n\n    transition: border-top-color 0.15s linear,\n      border-right-color 0.15s linear 0.1s,\n      border-bottom-color 0.15s linear 0.45s;\n  }\n\n  &::after {\n    border: 0 solid transparent;\n  }\n\n  &:hover::after {\n    border-top: 0.17vw solid #548dff;\n    border-left-width: 0.17vw;\n    border-right-width: 0.17vw;\n    transform: rotate(270deg);\n    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n  }\n}\n\n.circle {\n  border-radius: 100%;\n  box-shadow: none;\n\n  &::before,\n  &::after {\n    border-radius: 100%;\n  }\n}\n.button:hover {\n  transform: scale(1.1) rotate(135deg);\n  /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */\n  /* transform: rotate(45deg); */\n}\n\n/* Red bottom animations */\n.loadersHero2 {\n  width: 6.22vw;\n  height: 6.22vw;\n  transform: rotate(-45deg);\n\n  background: #fefefe;\n  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.loadersHero2 img {\n  width: 1.53vw;\n  margin-bottom: 0.65vw;\n}\n.loadersHero2 p {\n  width: 6vw;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.73vw;\n  /* or 10.29vw */\n  line-height: 1.3;\n\n  text-align: center;\n\n  color: #383838;\n}\n\n.button2 {\n  border: 0;\n  box-sizing: border-box;\n  width: 8.78vw;\n  height: 8.78vw;\n  border-radius: 50%;\n  /* padding: 1em 2em; */\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n  position: relative;\n  vertical-align: middle;\n\n  &::before,\n  &::after {\n    box-sizing: inherit;\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n}\n.spin2 {\n  transform: rotate(45deg);\n  width: 7.32vw;\n  height: 7.32vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    color: #ff0202;\n  }\n\n  &::before,\n  &::after {\n    top: 0;\n    left: 0;\n  }\n\n  &::before {\n    border: 0.17vw solid transparent;\n  }\n\n  &:hover::before {\n    border-bottom-color: #ff0202;\n\n    transition: border-top-color 0.15s linear,\n      border-right-color 0.15s linear 0.1s,\n      border-bottom-color 0.15s linear 0.45s;\n  }\n\n  &::after {\n    border: 0 solid transparent;\n  }\n\n  &:hover::after {\n    border-top: 0.17vw solid #ff0202;\n    border-left-width: 0.17vw;\n    border-right-width: 0.17vw;\n\n    transform: rotate(-270deg);\n    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n  }\n}\n.button2:hover {\n  transform: scale(1.1) rotate(45deg);\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n  /* transform: rotate(45deg); */\n}\n.circle2 {\n  border-radius: 100%;\n  box-shadow: none;\n\n  &::before,\n  &::after {\n    border-radius: 100%;\n  }\n}\n\n/* Green top animation */\n.loadersHero3 {\n  width: 6.22vw;\n  height: 6.22vw;\n  transform: rotate(-135deg);\n\n  background: #fefefe;\n  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /* border-top: 0.36vw solid #333;\n  border-bottom: none;\n  border-left: 0.36vw solid #333; */\n  /* border: 0.36vw 0.36vw 0 0 solid red; */\n  /* border-right: none; */\n}\n.loadersHero3 img {\n  width: 1.53vw;\n  margin-bottom: 0.65vw;\n}\n.loadersHero3 p {\n  width: 5vw;\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.73vw;\n  /* or 10.29vw */\n  line-height: 1.3;\n\n  text-align: center;\n\n  color: #383838;\n}\n\n.button3 {\n  border: 0;\n  box-sizing: border-box;\n  width: 8.78vw;\n  height: 8.78vw;\n  border-radius: 50%;\n  /* padding: 1em 2em; */\n  /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */\n\n  position: relative;\n  vertical-align: middle;\n\n  &::before,\n  &::after {\n    box-sizing: inherit;\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n}\n.spin3 {\n  transform: rotate(135deg);\n  width: 7.32vw;\n  height: 7.32vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    color: #20cc31;\n  }\n\n  &::before,\n  &::after {\n    top: 0;\n    left: 0;\n  }\n\n  &::before {\n    border: 0.17vw solid transparent;\n  }\n\n  &:hover::before {\n    /* border-top-color: #548DFF; */\n    /* border-right-color: #548dff; */\n    border-bottom-color: #20cc31;\n\n    transition: border-top-color 0.15s linear,\n      border-right-color 0.15s linear 0.1s,\n      border-bottom-color 0.15s linear 0.45s;\n  }\n\n  &::after {\n    border: 0 solid transparent;\n  }\n\n  &:hover::after {\n    border-top: 0.17vw solid #20cc31;\n    border-left-width: 0.17vw;\n    border-right-width: 0.17vw;\n    transform: rotate(270deg);\n    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n  }\n}\n\n.circle3 {\n  border-radius: 100%;\n  box-shadow: none;\n\n  &::before,\n  &::after {\n    border-radius: 100%;\n  }\n}\n.button3:hover {\n  transform: scale(1.1) rotate(135deg);\n  /* transform: scale(1.1); */\n  /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */\n\n  /* transform: rotate(45deg); */\n}\n\n/* Yellow Bottom Animation  */\n\n.loadersHero4 {\n  width: 6.22vw;\n  height: 6.22vw;\n  transform: rotate(-45deg);\n\n  background: #fefefe;\n  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.loadersHero4 img {\n  width: 1.53vw;\n  margin-bottom: 0.65vw;\n}\n.loadersHero4 p {\n  width: 7vw;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.73vw;\n  /* or 10.29vw */\n  line-height: 1.3;\n\n  text-align: center;\n\n  color: #383838;\n}\n\n.button4 {\n  border: 0;\n  box-sizing: border-box;\n  width: 8.78vw;\n  height: 8.78vw;\n  border-radius: 50%;\n  /* padding: 1em 2em; */\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n  position: relative;\n  vertical-align: middle;\n\n  &::before,\n  &::after {\n    box-sizing: inherit;\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n}\n.spin4 {\n  transform: rotate(45deg);\n  width: 7.32vw;\n  height: 7.32vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    color: #ffcb14;\n  }\n\n  &::before,\n  &::after {\n    top: 0;\n    left: 0;\n  }\n\n  &::before {\n    border: 0.17vw solid transparent;\n  }\n\n  &:hover::before {\n    /* border-top-color: #548DFF; */\n    /* border-right-color: #548dff; */\n    border-bottom-color: #ffcb14;\n\n    transition: border-top-color 0.15s linear,\n      border-right-color 0.15s linear 0.1s,\n      border-bottom-color 0.15s linear 0.45s;\n  }\n\n  &::after {\n    border: 0 solid transparent;\n  }\n\n  &:hover::after {\n    border-top: 0.17vw solid #ffcb14;\n    border-left-width: 0.17vw;\n    border-right-width: 0.17vw;\n    transform: rotate(-270deg);\n    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n  }\n}\n.button4:hover {\n  transform: scale(1.1) rotate(45deg);\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n  /* transform: rotate(45deg); */\n}\n.circle4 {\n  border-radius: 100%;\n  box-shadow: none;\n\n  &::before,\n  &::after {\n    border-radius: 100%;\n  }\n}\n\n/* Pink Bottom Animation */\n.loadersHero5 {\n  width: 6.22vw;\n  height: 6.22vw;\n  transform: rotate(-45deg);\n\n  background: #fefefe;\n  box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.loadersHero5 img {\n  width: 1.53vw;\n  margin-bottom: 0.65vw;\n}\n.loadersHero5 p {\n  width: 7vw;\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.73vw;\n  /* or 10.29vw */\n  line-height: 1.3;\n\n  text-align: center;\n\n  color: #383838;\n}\n\n.button5 {\n  border: 0;\n  box-sizing: border-box;\n  width: 8.78vw;\n  height: 8.78vw;\n  border-radius: 50%;\n  /* padding: 1em 2em; */\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n  position: relative;\n  vertical-align: middle;\n\n  &::before,\n  &::after {\n    box-sizing: inherit;\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n}\n.spin5 {\n  transform: rotate(45deg);\n  width: 7.32vw;\n  height: 7.32vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    color: #ff547d;\n  }\n\n  &::before,\n  &::after {\n    top: 0;\n    left: 0;\n  }\n\n  &::before {\n    border: 0.17vw solid transparent;\n  }\n\n  &:hover::before {\n    /* border-top-color: #548DFF; */\n    /* border-right-color: #548dff; */\n    border-bottom-color: #ff547d;\n\n    transition: border-top-color 0.15s linear,\n      border-right-color 0.15s linear 0.1s,\n      border-bottom-color 0.15s linear 0.45s;\n  }\n\n  &::after {\n    border: 0 solid transparent;\n  }\n\n  &:hover::after {\n    border-top: 0.17vw solid #ff547d;\n    border-left-width: 0.17vw;\n    border-right-width: 0.17vw;\n    transform: rotate(-270deg);\n    transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n  }\n}\n.button5:hover {\n  transform: scale(1.1) rotate(45deg);\n  box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n  /* transform: rotate(45deg); */\n}\n.circle5 {\n  border-radius: 100%;\n  box-shadow: none;\n\n  &::before,\n  &::after {\n    border-radius: 100%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .loadersHeroContainer {\n    padding: 0 0rem;\n    width: 100%;\n    display: flex;\n    /* flex-direction: column; */\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n  .spacingBox {\n    /* margin-right: 0.73vw; */\n  }\n  /* Active Styling */\n  .loadersHeroActive {\n    width: 100px;\n    height: 100px;\n    transform: rotate(-135deg);\n\n    background: #fefefe;\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08) !important;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  .loadersHeroActive img {\n    width: 30px;\n    margin-bottom: 0.65vw;\n  }\n  .loadersHeroActive p {\n    width: 70px;\n\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    text-align: center;\n    color: #383838;\n    margin-top: 5px;\n  }\n\n  .buttonActive {\n    border: 0;\n    box-sizing: border-box;\n\n    border-radius: 50%;\n\n    position: relative;\n    vertical-align: middle;\n\n    &::before,\n    &::after {\n      box-sizing: inherit;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n    }\n  }\n  .spinActive {\n    transform: rotate(135deg);\n    width: 120px;\n    height: 120px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 0.73vw;\n\n    &:hover {\n      color: #548dff;\n    }\n\n    &::before,\n    &::after {\n      top: 0;\n      left: 0;\n    }\n\n    &::before {\n      border: 2.4px solid transparent;\n    }\n\n    &::before {\n      border-bottom-color: #548dff;\n\n      transition: border-top-color 0.15s linear,\n        border-right-color 0.15s linear 0.1s,\n        border-bottom-color 0.15s linear 0.45s;\n    }\n\n    &::after {\n      border: 0 solid transparent;\n    }\n\n    &::after {\n      border-top: 2.4px solid #548dff;\n      border-left-width: 2.4px;\n      border-right-width: 2.4px;\n      transform: rotate(270deg);\n      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n    }\n  }\n\n  .circleActive {\n    border-radius: 100%;\n    box-shadow: none;\n\n    &::before,\n    &::after {\n      border-radius: 100%;\n    }\n  }\n\n  /* Blue 2 styling */\n  .loadersHero6 {\n    width: 100px;\n    height: 100px;\n    transform: rotate(-135deg);\n\n    background: #fefefe;\n    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  .loadersHero6 img {\n    width: 25px;\n    margin-bottom: 0.65vw;\n  }\n  .loadersHero6 p {\n    width: 80px;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n    text-align: center;\n    color: #383838;\n    margin-top: 3px;\n  }\n\n  .button6 {\n    border: 0;\n    box-sizing: border-box;\n    width: 140px;\n    height: 140px;\n    border-radius: 50%;\n    /* padding: 1em 2em; */\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n    position: relative;\n    vertical-align: middle;\n\n    &::before,\n    &::after {\n      box-sizing: inherit;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n    }\n  }\n  .spin6 {\n    transform: rotate(135deg);\n    width: 120px;\n    height: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: #548dff;\n    }\n\n    &::before,\n    &::after {\n      top: 0;\n      left: 0;\n    }\n\n    &::before {\n      border: 2.4px solid transparent;\n    }\n\n    &:hover::before {\n      border-bottom-color: #548dff;\n\n      transition: border-top-color 0.15s linear,\n        border-right-color 0.15s linear 0.1s,\n        border-bottom-color 0.15s linear 0.45s;\n    }\n\n    &::after {\n      border: 0 solid transparent;\n    }\n\n    &:hover::after {\n      border-top: 2.4px solid #548dff;\n      border-left-width: 2.4px;\n      border-right-width: 2.4px;\n      transform: rotate(270deg);\n      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n    }\n  }\n\n  .circle6 {\n    border-radius: 100%;\n    box-shadow: none;\n\n    &::before,\n    &::after {\n      border-radius: 100%;\n    }\n  }\n  .button6:hover {\n    transform: scale(1.1) rotate(135deg);\n    /* transform: rotate(45deg); */\n  }\n\n  /* Blue top animation */\n  .loadersHero {\n    width: 100px;\n    height: 100px;\n    transform: rotate(-135deg);\n\n    background: #fefefe;\n    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    /* border-top: 0.36vw solid #333;\n  border-bottom: none;\n  border-left: 0.36vw solid #333; */\n    /* border: 0.36vw 0.36vw 0 0 solid red; */\n    /* border-right: none; */\n  }\n  .loadersHero img {\n    width: 25px;\n    margin-bottom: 0.65vw;\n  }\n  .loadersHero p {\n    width: 30px;\n\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n    margin-top: 3px;\n    text-align: center;\n    color: #383838;\n  }\n\n  .button {\n    /* border: 0; */\n    box-sizing: border-box;\n    width: 140px;\n    height: 140px;\n    border-radius: 50%;\n    /* padding: 1em 2em; */\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n    position: relative;\n    vertical-align: middle;\n\n    &::before,\n    &::after {\n      box-sizing: inherit;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n    }\n  }\n  .spin {\n    transform: rotate(135deg);\n    width: 120px;\n    height: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: #548dff;\n    }\n\n    &::before,\n    &::after {\n      top: 0;\n      left: 0;\n    }\n\n    &::before {\n      border: 2.4px solid transparent;\n    }\n\n    &:hover::before {\n      /* border-top-color: #548DFF; */\n      /* border-right-color: #548dff; */\n      border-bottom-color: #548dff;\n\n      transition: border-top-color 0.15s linear,\n        border-right-color 0.15s linear 0.1s,\n        border-bottom-color 0.15s linear 0.45s;\n    }\n\n    &::after {\n      border: 0 solid transparent;\n    }\n\n    &:hover::after {\n      border-top: 2.4px solid #548dff;\n      border-left-width: 2.4px;\n      border-right-width: 2.4px;\n      transform: rotate(270deg);\n      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n    }\n  }\n\n  .circle {\n    border-radius: 100%;\n    box-shadow: none;\n\n    &::before,\n    &::after {\n      border-radius: 100%;\n    }\n  }\n  .button:hover {\n    transform: scale(1.1) rotate(135deg);\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n    /* transform: rotate(45deg); */\n  }\n\n  /* Red bottom animations */\n  .loadersHero2 {\n    width: 100px;\n    height: 100px;\n    transform: rotate(-45deg);\n\n    background: #fefefe;\n    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .loadersHero2 img {\n    width: 25px;\n    margin-bottom: 0.65vw;\n  }\n  .loadersHero2 p {\n    width: 80px;\n\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n    margin-top: 5px;\n    text-align: center;\n    color: #383838;\n  }\n\n  .button2 {\n    border: 0;\n    box-sizing: border-box;\n    width: 140px;\n    height: 140px;\n    border-radius: 50%;\n    /* padding: 1em 2em; */\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n    position: relative;\n    vertical-align: middle;\n\n    &::before,\n    &::after {\n      box-sizing: inherit;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n    }\n  }\n  .spin2 {\n    transform: rotate(45deg);\n    width: 110px;\n    height: 110px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: #ff0202;\n    }\n\n    &::before,\n    &::after {\n      top: 0;\n      left: 0;\n    }\n\n    &::before {\n      border: 2.4px solid transparent;\n    }\n\n    &:hover::before {\n      border-bottom-color: #ff0202;\n\n      transition: border-top-color 0.15s linear,\n        border-right-color 0.15s linear 0.1s,\n        border-bottom-color 0.15s linear 0.45s;\n    }\n\n    &::after {\n      border: 0 solid transparent;\n    }\n\n    &:hover::after {\n      border-top: 2.4px solid #ff0202;\n      border-left-width: 2.4px;\n      border-right-width: 2.4px;\n\n      transform: rotate(-270deg);\n      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n    }\n  }\n  .button2:hover {\n    transform: scale(1.1) rotate(45deg);\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n    /* transform: rotate(45deg); */\n  }\n  .circle2 {\n    border-radius: 100%;\n    box-shadow: none;\n\n    &::before,\n    &::after {\n      border-radius: 100%;\n    }\n  }\n\n  /* Green top animation */\n  .loadersHero3 {\n    width: 100px;\n    height: 100px;\n    transform: rotate(-135deg);\n\n    background: #fefefe;\n    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    /* border-top: 0.36vw solid #333;\n  border-bottom: none;\n  border-left: 0.36vw solid #333; */\n    /* border: 0.36vw 0.36vw 0 0 solid red; */\n    /* border-right: none; */\n  }\n  .loadersHero3 img {\n    width: 20px;\n    margin-bottom: 0.65vw;\n  }\n  .loadersHero3 p {\n    width: 70px;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n    margin-top: 5px;\n    text-align: center;\n    color: #383838;\n  }\n\n  .button3 {\n    border: 0;\n    box-sizing: border-box;\n    width: 140px;\n    height: 140px;\n    border-radius: 50%;\n    /* padding: 1em 2em; */\n    /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */\n\n    position: relative;\n    vertical-align: middle;\n\n    &::before,\n    &::after {\n      box-sizing: inherit;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n    }\n  }\n  .spin3 {\n    transform: rotate(135deg);\n    width: 120px;\n    height: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: #20cc31;\n    }\n\n    &::before,\n    &::after {\n      top: 0;\n      left: 0;\n    }\n\n    &::before {\n      border: 2.4px solid transparent;\n    }\n\n    &:hover::before {\n      /* border-top-color: #548DFF; */\n      /* border-right-color: #548dff; */\n      border-bottom-color: #20cc31;\n\n      transition: border-top-color 0.15s linear,\n        border-right-color 0.15s linear 0.1s,\n        border-bottom-color 0.15s linear 0.45s;\n    }\n\n    &::after {\n      border: 0 solid transparent;\n    }\n\n    &:hover::after {\n      border-top: 2.4px solid #20cc31;\n      border-left-width: 2.4px;\n      border-right-width: 2.4px;\n      transform: rotate(270deg);\n      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n    }\n  }\n\n  .circle3 {\n    border-radius: 100%;\n    box-shadow: none;\n\n    &::before,\n    &::after {\n      border-radius: 100%;\n    }\n  }\n  .button3:hover {\n    transform: scale(1.1) rotate(135deg);\n    /* transform: scale(1.1); */\n    /* box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08); */\n\n    /* transform: rotate(45deg); */\n  }\n\n  /* Yellow Bottom Animation  */\n\n  .loadersHero4 {\n    width: 100px;\n    height: 100px;\n    transform: rotate(-45deg);\n\n    background: #fefefe;\n    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .loadersHero4 img {\n    width: 20px;\n    margin-bottom: 0.65vw;\n  }\n  .loadersHero4 p {\n    width: 50px;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n    margin-top: 4px;\n    text-align: center;\n    color: #383838;\n  }\n\n  .button4 {\n    border: 0;\n    box-sizing: border-box;\n    width: 140px;\n    height: 140px;\n    border-radius: 50%;\n    /* padding: 1em 2em; */\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n    position: relative;\n    vertical-align: middle;\n\n    &::before,\n    &::after {\n      box-sizing: inherit;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n    }\n  }\n  .spin4 {\n    transform: rotate(45deg);\n    width: 120px;\n    height: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: #ffcb14;\n    }\n\n    &::before,\n    &::after {\n      top: 0;\n      left: 0;\n    }\n\n    &::before {\n      border: 2.4px solid transparent;\n    }\n\n    &:hover::before {\n      /* border-top-color: #548DFF; */\n      /* border-right-color: #548dff; */\n      border-bottom-color: #ffcb14;\n\n      transition: border-top-color 0.15s linear,\n        border-right-color 0.15s linear 0.1s,\n        border-bottom-color 0.15s linear 0.45s;\n    }\n\n    &::after {\n      border: 0 solid transparent;\n    }\n\n    &:hover::after {\n      border-top: 2.4px solid #ffcb14;\n      border-left-width: 2.4px;\n      border-right-width: 2.4px;\n      transform: rotate(-270deg);\n      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n    }\n  }\n  .button4:hover {\n    transform: scale(1.1) rotate(45deg);\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n    /* transform: rotate(45deg); */\n  }\n  .circle4 {\n    border-radius: 100%;\n    box-shadow: none;\n\n    &::before,\n    &::after {\n      border-radius: 100%;\n    }\n  }\n\n  /* Pink Bottom Animation */\n  .loadersHero5 {\n    width: 100px;\n    height: 100px;\n    transform: rotate(-45deg);\n\n    background: #fefefe;\n    box-shadow: 0 0.36vw 0.29vw rgba(0, 0, 0, 0.03) !important;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .loadersHero5 img {\n    width: 25px;\n    margin-bottom: 0.65vw;\n  }\n  .loadersHero5 p {\n    width: 80px;\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n    margin-top: 4px;\n    text-align: center;\n    color: #383838;\n  }\n\n  .button5 {\n    border: 0;\n    box-sizing: border-box;\n    width: 140px;\n    height: 140px;\n    border-radius: 50%;\n    /* padding: 1em 2em; */\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n\n    position: relative;\n    vertical-align: middle;\n\n    &::before,\n    &::after {\n      box-sizing: inherit;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n    }\n  }\n  .spin5 {\n    transform: rotate(45deg);\n    width: 120px;\n    height: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: #ff547d;\n    }\n\n    &::before,\n    &::after {\n      top: 0;\n      left: 0;\n    }\n\n    &::before {\n      border: 2.4px solid transparent;\n    }\n\n    &:hover::before {\n      /* border-top-color: #548DFF; */\n      /* border-right-color: #548dff; */\n      border-bottom-color: #ff547d;\n\n      transition: border-top-color 0.15s linear,\n        border-right-color 0.15s linear 0.1s,\n        border-bottom-color 0.15s linear 0.45s;\n    }\n\n    &::after {\n      border: 0 solid transparent;\n    }\n\n    &:hover::after {\n      border-top: 2.4px solid #ff547d;\n      border-left-width: 2.4px;\n      border-right-width: 2.4px;\n      transform: rotate(-270deg);\n      transition: transform 0.7s linear 0s, border-bottom-width 0s linear 0.6s;\n    }\n  }\n  .button5:hover {\n    transform: scale(1.1) rotate(45deg);\n    box-shadow: 0 0.95vw 2.19vw rgba(0, 0, 0, 0.08);\n    /* transform: rotate(45deg); */\n  }\n  .circle5 {\n    border-radius: 100%;\n    box-shadow: none;\n\n    &::before,\n    &::after {\n      border-radius: 100%;\n    }\n  }\n\n  .marginLoader {\n    /* margin: 0 5px; */\n    margin-bottom: 5px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
